const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    
let Utils = {
   	btoa: (input) => {
		let str = input;
		let output = '';
	
		for (let block = 0, charCode, i = 0, map = chars;
		str.charAt(i | 0) || (map = '=', i % 1);
		output += map.charAt(63 & block >> 8 - i % 1 * 8)) {
	
			charCode = str.charCodeAt(i += 3/4);
		
			if (charCode > 0xFF) {
				throw new Error("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
			}
			
			block = block << 8 | charCode;
		}
		
		return output;
	},
	  
	clearNumber: (value = '') => {
		return value.replace(/\D+/g, '');
	},
	
	formatCreditCardNumber: (value) => {
		if (!value) {
			return value;
		}
	
		const issuer = Payment.fns.cardType(value);
		const clearValue = Utils.clearNumber(value);
		let nextValue;
	
		switch (issuer) {
			case 'amex':
				nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
					4,
					10,
				)} ${clearValue.slice(10, 15)}`;
				break;
			case 'dinersclub':
				nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
					4,
					10,
				)} ${clearValue.slice(10, 14)}`;
				break;
			default:
				nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(
					4,
					8,
				)} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
				break;
		}
	
		return nextValue.trim();
	},
	
	formatCVC: (value, prevValue, allValues = {}) => {
		const clearValue = Utils.clearNumber(value);
		let maxLength = 4;
	
		if (allValues.number) {
			const issuer = Payment.fns.cardType(allValues.number);
			maxLength = issuer === 'amex' ? 4 : 3;
		}
	
		return clearValue.slice(0, maxLength);
	},
	
	formatExpirationDate: (value) => {
		const clearValue = Utils.clearNumber(value);
	
		if (clearValue.length >= 3) {
			return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
		}
	
		return clearValue;
	},
	
	formatFormData: (data) => {
		return Object.keys(data).map(d => `${d}: ${data[d]}`);
	}
};

export default Utils;



// WEBPACK FOOTER //
// ./util/index.js